import { Link, useLocation } from "react-router-dom";
import { Compass } from "lucide-react";
import { useI18n } from "@/i18n";

export const BrandHeader = ({ variant = "default" }) => {
  const location = useLocation();
  const isDashboard = location.pathname === "/dashboard";
  const { locale, setLocale, t } = useI18n();

  return (
    <header
      data-testid="brand-header"
      className="w-full border-b border-gold-500/20 bg-navy-900/85 backdrop-blur-md sticky top-0 z-40"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-logo">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-gold-500/15 blur-md group-hover:bg-gold-500/25 transition" />
            <Compass className="relative w-6 h-6 text-gold-300" strokeWidth={1.5} />
          </div>
          <div className="leading-tight">
            <div className="font-serif-cn text-gold-100 text-base font-semibold tracking-wide">
              Life Blueprint
            </div>
            <div className="text-[10px] tracking-[0.35em] text-gold-400/80 uppercase font-mono">
              {t("brand.subtitle")}
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          <Link
            to="/"
            className={`text-sm px-3 py-1.5 rounded-full transition ${
              location.pathname === "/"
                ? "text-gold-200 bg-gold-500/10"
                : "text-slate-300 hover:text-gold-200"
            }`}
            data-testid="nav-home"
          >
            {t("nav.home")}
          </Link>
          <Link
            to="/form"
            className={`text-sm px-3 py-1.5 rounded-full transition ${
              location.pathname === "/form"
                ? "text-gold-200 bg-gold-500/10"
                : "text-slate-300 hover:text-gold-200"
            }`}
            data-testid="nav-form"
          >
            {t("nav.form")}
          </Link>
          <div
            className="flex items-center rounded-full border border-gold-500/30 bg-navy-800/60 p-0.5"
            data-testid="language-switcher"
            aria-label="Language"
          >
            <button
              type="button"
              data-testid="language-zh"
              aria-pressed={locale === "zh"}
              onClick={() => setLocale("zh")}
              className={`text-[11px] px-2.5 py-1 rounded-full transition ${
                locale === "zh"
                  ? "bg-gold-500/15 text-gold-100"
                  : "text-slate-400 hover:text-gold-200"
              }`}
            >
              {t("language.zh")}
            </button>
            <button
              type="button"
              data-testid="language-en"
              aria-pressed={locale === "en"}
              onClick={() => setLocale("en")}
              className={`text-[11px] px-2.5 py-1 rounded-full transition ${
                locale === "en"
                  ? "bg-gold-500/15 text-gold-100"
                  : "text-slate-400 hover:text-gold-200"
              }`}
            >
              {t("language.en")}
            </button>
          </div>

          {isDashboard && (
            <span className="text-xs tracking-widest px-3 py-1 rounded-full border border-gold-500/40 text-gold-200 bg-gold-500/5">
              V2.9.9
            </span>
          )}
        </nav>
      </div>
    </header>
  );
};

export default BrandHeader;
